/**
 * Unsent chat drafts per conversation key, for the editor session (spec 022):
 * switching scenes or tabs and back restores the draft. In memory only.
 */
import { create } from 'zustand';

interface ChatDraftState {
  drafts: Record<string, string>;
  setDraft: (key: string, value: string) => void;
  reset: () => void;
}

export const useChatDrafts = create<ChatDraftState>()((set) => ({
  drafts: {},
  setDraft: (key, value) => set((s) => (s.drafts[key] === value ? s : { drafts: { ...s.drafts, [key]: value } })),
  reset: () => set({ drafts: {} }),
}));
